import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";

import { QNAPage } from "./QNA";
import { LayoutSplashScreen, ContentRoute } from "../../../_metronic/layout";

import { URLs } from "../../../utils/routes";

export function CSPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact={true} from={URLs.CS} to={URLs.CS_QNA} />
        <ContentRoute path={URLs.CS_QNA} component={QNAPage} />
      </Switch>
    </Suspense>
  );
}
